import { styled as muiStyled } from "@mui/material/styles";

/**
 * styled function wrapper for creating styled components.
 * Wraps Material-UI styled for consistent imports.
 * 
 * @example
 * const StyledButton = styled(Button)(({ theme }) => ({
 *   color: theme.palette.primary.main,
 * }));
 */
export const styled = muiStyled;

export default styled;
